import React from 'react';
import Skeleton from '@components/atoms/Skeleton/Skeleton';
import {
  FooterWrapper,
  ProductContainer,
  ProductInformation,
  ProductWrapper,
  SkeletonPageBeamFilters,
  SkeletonPageBeamWrapper,
  SkeletonProductWrapper,
  SkeletonWrapper,
  SkeletonHeader,
  SkeletonBreadCrumbs,
  SkeletonResults,
  SkeletonPromotionPageBeamWrapper,
  SkeletonFilter,
  SkeletonSorting,
  SkeletonPageHeader,
  SkeletonResultsWrapper,
  SkeletonResultsMobile,
  SkeletonFiltersMobile,
} from './ProductBeam.skeleton.styles';

interface Props {
  type?: 'buyAll' | 'pageBeam' | 'productBeam' | 'promotionBeam' | 'categoryBeam';
  offlineProduct?: boolean;
  rows?: number;
  hasTitle?: boolean;
}

const ProductBeamSkeleton = ({ type = 'productBeam', offlineProduct, rows = 1, hasTitle }: Props) => {
  const amountOfProducts = 7 * rows;

  const skeletonProduct = () => {
    const productArray = [];
    for (let i = 0; i < amountOfProducts; i += 1) {
      productArray.push(
        <ProductContainer key={i} $offlineProduct={offlineProduct}>
          <ProductWrapper>
            <Skeleton type="rect" height={167} />
            <ProductInformation>
              <Skeleton type="rect" height={16} width="70%" />
              <Skeleton type="rect" height={16} width="50%" />
            </ProductInformation>
            {!offlineProduct && <Skeleton type="button" height={46} />}
          </ProductWrapper>
        </ProductContainer>
      );
    }
    return productArray;
  };

  return (
    <SkeletonWrapper $type={type}>
      {type === 'categoryBeam' && <SkeletonBreadCrumbs type="rect" height={20} width={160} noMargin />}
      {type === 'categoryBeam' && <SkeletonFiltersMobile type="rect" height={32} noMargin />}
      {(type === 'productBeam' || type === 'buyAll') && !hasTitle && (
        <SkeletonHeader type="rect" height={28} width={300} />
      )}
      {(type === 'pageBeam' || type === 'categoryBeam') && (
        <SkeletonPageBeamWrapper $variant={type}>
          <SkeletonPageHeader type="rect" height={36} noMargin $variant={type} />
          <SkeletonPageBeamFilters $type={type}>
            <SkeletonFilter type="button" height={40} noMargin $variant={type} />
            <SkeletonSorting type="button" height={40} noMargin $variant={type} />
          </SkeletonPageBeamFilters>
          {type === 'categoryBeam' && <SkeletonResults type="text" width={64} height={20} noMargin />}
        </SkeletonPageBeamWrapper>
      )}
      {type === 'pageBeam' && (
        <SkeletonResultsWrapper>
          <SkeletonResultsMobile type="text" width={60} height={20} noMargin />
          <Skeleton type="text" width={134} height={20} noMargin />
        </SkeletonResultsWrapper>
      )}
      {type === 'promotionBeam' && (
        <SkeletonPromotionPageBeamWrapper>
          <SkeletonPageBeamFilters>
            <Skeleton type="button" height={40} width={113} noMargin />
            <Skeleton type="rect" height={20} width={60} noMargin />
          </SkeletonPageBeamFilters>
        </SkeletonPromotionPageBeamWrapper>
      )}

      <SkeletonProductWrapper
        data-testid="productbeam-skeleton"
        $offlineProduct={offlineProduct}
        $type={type}
        $rows={rows}
      >
        {skeletonProduct()}
      </SkeletonProductWrapper>

      {type !== 'pageBeam' && type !== 'categoryBeam' && (
        <FooterWrapper>
          {type !== 'buyAll' && type !== 'promotionBeam' && (
            <>
              <Skeleton type="rect" height={16} width={98} />
              <Skeleton type="rect" height={8} width={180} />
            </>
          )}
          <Skeleton type="button" height={52} width={110} />
        </FooterWrapper>
      )}
    </SkeletonWrapper>
  );
};

export default ProductBeamSkeleton;
